import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportParamsService {
  private _paramsSubject = new BehaviorSubject<Record<string, string>>({});
  public params$ = this._paramsSubject.asObservable();

  setParams(params: Record<string, string>) {
    this._paramsSubject.next(params);
  }

  getParams(): Record<string, string> {
    return this._paramsSubject.getValue();
  }
  objectToQueryString(params: Record<string, string | number | boolean>): string {
    return Object.entries(params)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
  }
  constructor() { }
}
